module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      List Management\n    ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("List Name")]), _vm._v(" "), _c('th', [_vm._v("List Type")]), _vm._v(" "), _c('th', [_vm._v("List Description")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.lists.all_lists), function(listname) {
    return _c('tr', {
      class: {
        'editable': listname.type !== 'global'
      },
      on: {
        "click": function($event) {
          _vm.selectList(listname)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(listname.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listname.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listname.description))]), _vm._v(" "), _c('td', {
      class: {
        green: listname.enabled, red: !listname.enabled
      }
    }, [_vm._v(_vm._s(listname.enabled ? 'ACTIVE' : 'INACTIVE')), (listname.type === 'global') ? _c('span', {
      staticClass: "readonly"
    }, [_vm._v(" (readonly)")]) : _vm._e()])])
  }))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72985e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/lists/list/index.vue
// module id = 229
// module chunks = 1